import { GeneralData, VhcItem } from './types';
import { create } from 'zustand';

interface RecordState {
  generalData: GeneralData | null;
  setGeneralData: (generalData: GeneralData) => void;
  items: VhcItem[] | null;
  setItems: (items: VhcItem[] | null) => void;
  reset: () => void;
}

export const useRecordStore = create<RecordState>((set) => ({
  generalData: null,
  items: null,
  setGeneralData: (generalData) => set({ generalData }),
  setItems: (items) => set({ items }),
  reset: () => set({ generalData: null, items: null })
}));
